module.exports = __webpack_public_path__ + "static/bold-c0869bba2fa145ce469aa2118e75ad31.jpg";